$(document).ready ( function(){
  $(".only-desktop ul.list-menu.list-menu--inline li.top-list-wrapper.child-link-available").mouseenter(function(){
    $('body').addClass('menu-list-active');
  })
  $(".only-desktop ul.list-menu.list-menu--inline li.top-list-wrapper").mouseenter(function(){
  $(this).addClass("active-menu");
    $(this).find(".custom-mega-menu__content").addClass("active-menu");
    
  });
  $(".only-desktop ul.list-menu.list-menu--inline li.top-list-wrapper").mouseleave(function(){
    $(".main-top-header ul.list-menu.list-menu--inline li.top-list-wrapper").removeClass("active-menu");
    $(".main-top-header .custom-mega-menu__content").removeClass("active-menu");
    $('body').removeClass('menu-list-active');
  });
  // ------------------- mega menu right------------
    $(".main-top-header .only-desktop ul.list-menu.list-menu--inline li.top-list-wrapper li.childlist-wrapper").mouseenter(function(){
  $(this).addClass("child-active-menu");
    $(this).find("ul.custom-list-unstyled").addClass("child-active-menu");
  });
  $(".main-top-header .only-desktop ul.list-menu.list-menu--inline li.top-list-wrapper li.childlist-wrapper").mouseleave(function(){
    $(".main-top-header .only-desktop ul.list-menu.list-menu--inline li.top-list-wrapper li.childlist-wrapper").removeClass("child-active-menu");
    $(".main-top-header ul.custom-list-unstyled").removeClass("child-active-menu");
  });
      
  //  $('.uk-button.uk-button-primary.first, .uk-button.uk-button-primary.second').on('click', function() {
  //   $('.uk-button.uk-button-primary.first, .uk-button.uk-button-primary.second').toggle();
  // });
    
    var $status = $('.hero-banner .pagingInfo');
    var $slickElement = $('.hero-banner #hero-main-bannner');
  
    $slickElement.slick({
      autoplay: false,
      dots: false,
      arrow:true,
    });
  
    $("#hero-main-bannner .main-banner-video video").prop('muted', true);
  $("#banner-volumn-control").click( function (){
    if ($("#banner-volumn-control").hasClass("fa-volume-off")) 
    {
      $(this).removeClass('fa-volume-off');
      $(this).addClass('fa-volume-high');
      
      $("#hero-main-bannner .main-banner-video video").prop('muted', false);
    }
    else {
      $(this).removeClass('fa-volume-high');
      $(this).addClass('fa-volume-off');
      $("#hero-main-bannner .main-banner-video video").prop('muted', true);
    }
  });
    $( window ).on("load", function() {
    var current_url = window.location.href
  localStorage.setItem('local-storage',current_url);
    });
    
   $('.main-close-btn').on('click',function() {
     var cookie_set = localStorage.getItem('local-storage');
     window.history.replaceState({},'',''+cookie_set);
      $('.custom-wrap-popup').removeClass('custom-pdp-popup-open');
      $('body').removeClass('pdp-popup-open');
      $('.custom-wrapper-product-drawer').empty();
       $('body').removeClass(' overflow-hidden');
    });
    // ------------filter js-------
  // -on load ----------
  var value_name = $('ul#filter-dropdown li.custom-dropdow.active-tag').attr('value_name');
    $('.filter-sorting-cstm .dropdown-range .section_box .selected-value').text(value_name);
  // -on load end ----------
  $(".facet-filters-cstm .filter-sorting-cstm .dropdown-range").click(function () {
    $(this).toggleClass('active-filters');
    $('body').toggleClass('dropdown-active');
  });
    
  $("ul#filter-dropdown li.custom-dropdow").click(function(){
    var value_id = $(this).attr('value_name');
    $('ul#filter-dropdown li.custom-dropdow').removeClass('active-tag');
    $(this).addClass('active-tag');
    $('.filter-sorting-cstm .dropdown-range .section_box .selected-value').text(value_id);
    var selected_val = $(this).attr('value');
    var current_url =  window.location.href;
     if(window.location.href.indexOf("sort_by") > -1) {
       var href = new URL(window.location.href);
        href.searchParams.set('sort_by', selected_val);
         var location_main = href.toString();  
      }
      else{
        var location_main = current_url+"?sort_by="+selected_val ;
      }
    window.history.replaceState({},'',''+location_main);
    var link_data= window.location.href;
    $.ajax({
    url: link_data,
    type:'GET',
    success:function(result_tags1){
      var get_results= $(result_tags1).find("div#ProductGridContainer")
      $("div#ProductGridContainer").html(get_results); 
    }
    });
  });

  // -----------information section jquery-------------
  $('.main-subinf-wrap .left-wrap .sub-left-heading').on('click',function() {
    $('.main-subinf-wrap .left-wrap .sub-left-heading').removeClass('below-active-heading');
    $(this).addClass('below-active-heading');
    var val_name = $(this).attr('data-value');
    $('.information-section div#headings-container h2.cstm-heading-information').removeClass('active-heading');
    $('.information-section div#headings-container h2.cstm-heading-information[heading_name="' + val_name + '"]').addClass('active-heading');
    $('.information-section .sub-right-content').removeClass('content-active-heading');
    $('.main-subinf-wrap .left-wrap .sub-left-heading').removeClass('below-active-heading');
    $('.right-wrap .sub-right-content[data-value="' + val_name + '"]').addClass('content-active-heading');
     $('.main-subinf-wrap .left-wrap .sub-left-heading[data-value="' + val_name + '"]').addClass('below-active-heading');
 // -------------information page faq ----------
    $('.information-section .sub-right-content.content-active-heading .faq-item .custom-question').on('click',function() {
    if ($(this).hasClass("active")) {}
    else{
        $('.information-section .sub-right-content.content-active-heading .faq-item .custom-question').removeClass('active');
        $(this).addClass('active');
        $(".information-section .sub-right-content.content-active-heading .faq-item .custom-amswer").slideUp(500);
        $(this).siblings(".custom-amswer").slideDown(500);
    }
  });
  });
$('.custom-testimonial-sec .review-box').slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll:1,
  arrow:true,
  prevArrow:'<button class="previous-arrow"><svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 1L1 11L11 21" stroke="#1C1C1C" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  nextArrow:'<button class="next-arrow"><svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 21L11 11L1 1" stroke="#1C1C1C" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots:true,
      }
    }
  ]
});
 // ---------------search all js ------------------
  $(".search-filter-sorting-cstm .search-options").click(function () {
    $(this).toggleClass('active-search');
    $('body').toggleClass('search-dropdown-active');
  });
   $(".search-filter-sorting-cstm .search-options ul#wrapper-search li").click(function(){
     var value_li = $(this).text();
     $('.search-filter-sorting-cstm .search-section_box .search-selected-value').text(value_li);
     $('input#Search-In-Modal').val(value_li);
var input = document.querySelector("input#Search-In-Modal");
var inputEvent = new Event("input", { bubbles: true });
    input.dispatchEvent(inputEvent);
 });
// -----------collection list remove class with screen--------------
  if ($(document).width() < 1366) {
    $('.custom_coll.collection-list .custom_collection_list .collection-list.grid').removeClass('grid--7-col-desktop');
  }
  else{
    $('.custom_coll.collection-list .custom_collection_list .collection-list.grid').addClass('grid--7-col-desktop');
  }
  
$(window).resize(function() {
  if ($(document).width() < 1366) {
    $('.custom_coll.collection-list .custom_collection_list .collection-list.grid').removeClass('grid--7-col-desktop');
  }
  else{
    $('.custom_coll.collection-list .custom_collection_list .collection-list.grid').addClass('grid--7-col-desktop');
  }
});

  var jq224 = jQuery.noConflict(true);
  jq224(document).on('click', '.collection-hero__text-wrapper .read-more-collection', function(e){
    e.preventDefault();
    if (jq224('#fullDescription').is(':visible')) {
      jq224('#fullDescription').fadeOut(300, function(){
        jq224('#truncated').fadeIn(500);
        jq224('.read-more-collection').html('Show More<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L6 6L11 1" stroke="#D4AF37" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>');
      });
    } else {
      jq224('#truncated').fadeOut(300, function(){
        jq224('#fullDescription').fadeIn(500);
        jq224('.read-more-collection').html('Show Less<svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 6L6 1L1 6" stroke="#D4AF37" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>');
      });
    }
  });

  
});


function myFunctionpopup(d) { 
let sibling = d.previousElementSibling;

  while (sibling) {
    if (sibling.classList.contains('quick-add__submit')) {
      sibling.click();
      break;
    }
    sibling = sibling.previousElementSibling;
  }
  $('.custom-wrap-popup').addClass('custom-pdp-popup-open');
  $('body').addClass('pdp-popup-open');
  var link_data = d.getAttribute("data-product-url")
 var data_url = d.getAttribute('cstm-data-modal');
    var data_main_content = d.getAttribute('main-data-modal');
   $(data_url).css("display", "none");
     $('.custom-wrap-popup').addClass('custom-pdp-popup-open');
  $('body').addClass('pdp-popup-open');
    setTimeout(function() {
     var get_results= $('body').find(".quick-add-modal div"+data_main_content+' .gradient.color-scheme-2');
        console.log(get_results);
      $(".custom-wrap-popup .custom-wrapper-product-drawer").html(get_results); 
      $(".filters-select-main").click(function () {
       console.log('popup-work')
      var data_url_new = $(this).attr('data-modal');
     console.log(data_url_new);
      setTimeout(function() {
     if ($("body").hasClass("pdp-popup-open") == true) {   
    }
    else {
   $(data_url_new).css("display", "block");
    }
      },1000);
    });

  $('.custom-wrapper-product-drawer .buy-pdp-wrapper .product-form  .product-form__submit.button.button--full-width.button--primary').click(function () {
    setTimeout(function() {
    $('.main-custom-wrapper-product-drawer .main-close-btn').trigger('click');
    },2000);
  });
    },1500);
}
function myquantity(d) {
    setTimeout(function() {
var text_count = $('.template-cart .cstm-cart-content ul .item-li-main .total-pdp-cstm').attr('total');
    $('cart-items .title-wrapper-with-link .gogna-total-item .total-cart-items').text(text_count);
    },2000);
};
  


